export default "__VITE_ASSET__vnEiMTRi__"